import { datadogRum } from '@datadog/browser-rum'

export const Datadog = datadogRum
